import { render } from "./Casting.vue?vue&type=template&id=4fb022f0"
import script from "./Casting.vue?vue&type=script&lang=js"
export * from "./Casting.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\jump\\front\\jumpsa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__